import React from 'react';
import PropTypes from 'prop-types';
import './OnboardingCompleted.scss';
import LazyFinish from '../Finish/LazyFinish';
import onboardingCompleted from '../../../../assets/images/onboarding-completed.svg';
import { analyticsTrack } from '../../../analyticsUtils';

function OnboardingCompleted({
  csrfToken, profileUrl, userId, onboardType,
}) {
  const onViewProjects = () => {
    analyticsTrack('Clicking on View Projects', {
      location: 'Onboarding Flow',
      userId,
    });
  };

  const onAddProfileDetails = () => {
    analyticsTrack('Clicking on View Profile', {
      location: 'Onboarding Flow',
      userId,
    });
  };

  if (onboardType === 'lazy_onboard') {
    return (
      <LazyFinish
        csrfToken={csrfToken}
        onboardType={onboardType}
      />
    );
  }
  return (
    <div className="onboarding-completed ">
      <div className="completed-container">
        <img alt="Completed Checklist" src={onboardingCompleted} className="completed-image" />
        <h2 className="header">All done!</h2>
        <div className="text-1">
          We have all the information we need to start matching you with employers.
        </div>
        <div className="text-2">
          You may now
          {' '}
          <strong>view available projects</strong>
          {' '}
          that match your profile. You may also
          continue to
          {' '}
          <strong>add detail to your profile</strong>
          {' '}
          to receive even more relevant
          project listings.
        </div>
        <div className="btn-container mt-40">
          <a
            className="btn btn-primary view-project-btn"
            id="view-project-link"
            onClick={() => onViewProjects()}
            href="/opportunities"
          >
            View projects
          </a>
          <a
            className="btn btn-primary add-to-profile-btn"
            id="add-profile-link"
            onClick={() => onAddProfileDetails()}
            href={profileUrl}
          >
            View Profile
          </a>
        </div>
      </div>
      <div className="mobile-footer">
        <div className="navbar navbar-expand-lg">
          <div className="container">
            <button
              type="button"
              className="navbar-toggler collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#clora-footer-navbar"
              aria-label="Toggle navigation"
              aria-expanded="false"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <span className="navbar-text navbar-brand">
              ©
              {' '}
              {new Date().getFullYear()}
              {' '}
              Clora
            </span>
          </div>

          <div className="collapse navbar-collapse" id="clora-footer-navbar">
            <ul className="nav navbar-nav navbar-right">
              <li><a href="/privacy-policy">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
OnboardingCompleted.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  profileUrl: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  onboardType: PropTypes.string.isRequired,
};

export default OnboardingCompleted;
